import config from "../../config.json";
const BASE_AUTH_API = config.BASE_AUTH_API;

// comp
export const fetchCompsAPI = async (token, sId, branch = false) => {
  let responseData;
  try {
    const params = new URLSearchParams();
    sId.forEach((id) => params.append("sId", id));
    params.append("branch", branch ? "yes" : undefined);

    const url = `${BASE_AUTH_API}report/compensation?${params.toString()}`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
// comp
export const fetchBranchesCompsAPI = async (token, sId, branches) => {
  let responseData;
  try {
    const params = new URLSearchParams();
    sId.forEach((id) => params.append("sId", id));
    const params2 = new URLSearchParams();
    branches.forEach((branch) => params2.append("assignedBranch", branch));

    const url = `${BASE_AUTH_API}report/compensation/branch?${params.toString()}&${params2.toString()}`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const updateCompAPI = async (token, id, data) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/compensation/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.updated;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

// storeIds (LUD store codes) scope approvals to stores by identity;
// the store display name is kept for servers that predate it.
export const updateCompByStoreDateAppAPI = async (token, store, date, app, storeIds = []) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/compensation/approve`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ store, date, app, storeIds }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const deleteCompAPI = async (token, id) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/compensation/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
export const deleteCompByIdsAPI = async (token, ids) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/compensation/by-ids`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ids }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

// daily
export const fetchDailysAPI = async (token, sId) => {
  let responseData;
  try {
    const params = new URLSearchParams();
    sId.forEach((id) => params.append("sId", id));
    const url = `${BASE_AUTH_API}report/daily?${params.toString()}`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const updateDailyAPI = async (token, id, data) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/daily/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.updated;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
export const updateDailyByStoreDateAppAPI = async (token, store, date, app, storeIds = []) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/daily/approve`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ store, date, app, storeIds }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const deleteDailyAPI = async (token, id) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/daily/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
export const deleteDailyByIdsAPI = async (token, ids) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/daily/by-ids`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ids }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

// monthly
export const fetchMonthlysAPI = async (token, sId) => {
  let responseData;
  try {
    const params = new URLSearchParams();
    sId.forEach((id) => params.append("sId", id));
    const url = `${BASE_AUTH_API}report/monthly?${params.toString()}`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const updateMonthlyAPI = async (token, id, data) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/monthly/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.updated;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
export const updateMonthlyByStoreDateAppAPI = async (
  token,
  store,
  date,
  app,
  storeIds = [],
) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/monthly/approve`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ store, date, app, storeIds }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
export const updateDisapproveByStoreDateAppAPI = async (
  token,
  type,
  store,
  date,
  app,
  storeIds = [],
) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/${type}/disapprove`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ store, date, app, storeIds }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
export const deleteMonthlyAPI = async (token, id) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/monthly/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};
export const deleteMonthlyByIdsAPI = async (token, ids) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/monthly/by-ids`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ids }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    
    return;
  }
};

export const updateApprovalByStoreDateAPI = async (
  token,
  type,
  store,
  date,
  isApproved,
  storeIds = [],
) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}report/${type}/date-approve`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ store, date, isApproved, storeIds }),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      console.log(responseData.error);
      return;
    }
  } catch (error) {
    
    return;
  }
};
